import { CheckBoxIcon } from '../../../../assets';

export const PHYSICIAN_ENGAGEMENT_CHANNELS = [
    'All',
    'E-mail',
    'Programmatic',
    'Direct Mail',
    'EHR',
    'Mobile',
    'Peer to Peer',
    'Point of Care'
];

export const BAR_CHART_LEGENDS = [
    { label: 'E-mail', icon: <CheckBoxIcon fill="#FD853A"/> },
    { label: 'Programmatic', icon: <CheckBoxIcon fill="#7A5AF8" /> },
    { label: 'Direct mail', icon: <CheckBoxIcon fill="#12B76A"/> },
    { label: 'EHR', icon: <CheckBoxIcon fill="#2E90FA"/> },
    { label: 'Mobile', icon: <CheckBoxIcon fill="#6172F3"/> },
    { label: 'Peer To Peer', icon: <CheckBoxIcon fill="#F63D68"/> },
    { label: 'Point of Care', icon: <CheckBoxIcon fill="#EE46BC"/> }
];


export const CHART_OPTIONS = {
    chart: {
        stacked: true,
        toolbar: { show: false }
    },
    noData: {
        text: 'No data to display',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
            color: '#000000',
            fontSize: '14px'
        }
    },
    legend: {
        show: true,
        position: 'top',
        horizontalAlign: 'center',
        markers: {
            shape: 'circle',
            radius: 6
        }
    },
    xaxis: {
        title: {
            text: 'Channels',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-xaxis-title'
            }
        },
        crosshairs: { show: false }
    },
    yaxis: {
        title: {
            text: 'Total Physicians',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-xaxis-title'
            }
        },
        min: 0,
        max: 10,
        tickAmount: 5
    },
    tooltip: {
        enabled: true,
        custom: function ({
            series, seriesIndex, dataPointIndex, w 
        }) {
            const value = series[seriesIndex][dataPointIndex];
            const label = w.globals.labels[dataPointIndex];
            const data = w.globals.initialSeries[seriesIndex].data[dataPointIndex];
            const { colors } = w.globals;
            const serieLabels = w.globals.seriesNames;
            let serieItems = '';
            
            const serieTitle= '<div class="apexcharts-tooltip-title">'+label+'</div>';
            
            series.forEach((array, index) => {
                const serieValue = array[dataPointIndex];
                const serieLabel = serieLabels[index];
                const serieColor = colors[index];
      
                if (serieValue && serieValue !== 0) {
                    serieItems +=
                    '<div class="apexcharts-tooltip-series-group apexcharts-active" style="order:'+index+';display:flex;">'+
                        '<span class="apexcharts-tooltip-marker" style="background-color: '+serieColor+';"></span>'+
                        '<div class="apexcharts-tooltip-text">'+ 
                            '<div class="apexcharts-tooltip-y-group">' +
                                '<span class="apexcharts-tooltip-text-y-label">' + serieLabel +':</span>'+
                                '<span class="apexcharts-tooltip-text-y-value">'+serieValue+'</span>'+
                            '</div>'+
                        '</div>'+
                    '</div>';
                }
              
            });
           
            return serieTitle + serieItems;
        }
    },
    plotOptions: {
        bar: {
            columnWidth: 50,
            borderRadius: 2,
            dataLabels: { position: 'top' }
        }
        
    },
    stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
    },
    dataLabels: {
        enabled: true,
        textAnchor: 'middle',
        style: {
            colors: ['#FFFFFF'],
            fontSize: '12px',
            fontWeight: '500'                    
        },
        formatter: function (val, opt) {
            const formattedVal = val.toString();
            return formattedVal;
        }
    }

};

export const CHART_SERIES = [
    {
        name: 'Physicians Engagement Channel',
        data: [
            {
                x: 'E-mail', y: 16.7, fillColor: '#FD853A' 
            },
            {
                x: 'Programmatic', y: 29.4, fillColor: '#7A5AF8' 
            },
            {
                x: 'Direct mail', y: 17.7, fillColor: '#12B76A' 
            },
            {
                x: 'EHR', y: 9.1, fillColor: '#2E90FA' 
            },
            {
                x: 'Mobile', y: 24.8, fillColor: '#6172F3' 
            },
            {
                x: 'Peer To Peer', y: 16.7, fillColor: '#F63D68' 
            },
            {
                x: 'Point of Care', y: 23.3, fillColor: '#EE46BC' 
            }
        ]
    }
];
